var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "expedient-actions" },
      [
        _vm.gridColumns
          ? _c("GridTableComponent", {
              ref: "grid",
              attrs: {
                itemsData: _vm.gridData,
                gridConfiguration: _vm.gridColumns,
                title: _vm.title,
                toolbarOptions: _vm.customToolbarOptions,
                contextMenuItems: _vm.contextMenuItemsWithoutRemove,
                listName: _vm.listName,
                context: _vm.agendaContext,
                showHeader: false,
                isInTab: "",
                commandClick: _vm.onCommandClick,
              },
              on: {
                cellClicked: _vm.onCellClicked,
                contextMenuClicked: _vm.onContextMenuClicked,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm.showCalendarDialog
      ? _c(
          "div",
          {
            staticClass: "dialog-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.checkIfHideDialog.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "dialog-message-container" }, [
              _c("header", { staticClass: "dialog-header" }, [
                _c("span", { staticClass: "dialog-header-text" }, [
                  _vm._v(_vm._s(_vm.labelDialog)),
                ]),
                _c("span", {
                  class: [_vm.icons.close, "icon-close"],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.hideDialog.apply(null, arguments)
                    },
                  },
                }),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSpinner,
                      expression: "showSpinner",
                    },
                  ],
                  staticClass: "lf-dialog-spinner",
                },
                [_c("SpinnerLayerComponent", { staticClass: "spinner-layer" })],
                1
              ),
              _c("iframe", {
                attrs: { src: _vm.url, frameborder: "0", allowfullscreen: "" },
              }),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }